<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
<div class="wrap">
  <h3>{{ data.title }}</h3>
  <p class="whitespace-pre-line">{{ data.message }}</p>

  <!-- Password Input Field -->
  <div *ngIf="data.showPasswordField" class="password-field">
    <form [formGroup]="passwordForm">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ passwordLabel }}</mat-label>
        <input [disabled]="isLoading" matInput [type]="hidePassword ? 'password' : 'text'" formControlName="password"
          [placeholder]="passwordPlaceholder">
        <button mat-icon-button matSuffix type="button" (click)="hidePassword = !hidePassword"
          [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidePassword">
          <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
        <mat-error *ngIf="passwordForm.get('password')?.hasError('invalid')">
          Incorrect password
        </mat-error>

        <mat-error *ngIf="passwordForm.get('password')?.hasError('required')">
          Password is required
        </mat-error>
      </mat-form-field>
    </form>
  </div>

  <div class="button-container">
    <button *ngIf="data.cancelButtonHide != true" mat-flat-button (click)="onClose()" class="cancel-btn">
      {{ data.cancelButtonText || "Cancel" }}
    </button>
    <button mat-flat-button (click)="confirm()" color="primary" class="save-btn"
      [disabled]="isLoading">
      {{ data.confirmButtonText || "Confirm" }}
    </button>
  </div>
</div>
